export default __webpack_public_path__ + "static/media/escudo.1b357dbf.svg";